<template lang="pug">
  .grid-list-icon
    .grid-item(
      v-for="(item, index) in gridList"
      :key="item.gridName"
      @click="handleGridClick(item, index)"
      v-platform-expose="{ handler: handleGridExpose, data: { item, index } }"
    )
      .grid-icon-wrapper
        .corner-text(v-if="item.cashBackV2CornerMarkText") {{ item.cashBackV2CornerMarkText }}
        img.grid-icon(
          :src="item.imgUrl"
          :alt="item.gridName"
          @error="(e) => e.target.src = defaultIcon"
        )
      span.grid-name {{ item.gridName }}
      span.grid-subtitle {{ item.subTitle }}
</template>

<script>
import { ParamsUtil } from '@/utils/params';
import SPM from '../../../common/spm';

const DEFAULT_ICON = 'https://m.hellobike.com/resource/gallery/3/yGT9K-H-_default-icon.png';

export default {
  name: 'CashbackGridIcon',
  props: {
    gridList: {
      type: Array,
      default: () => [],
    },
  },
  inject: ['cashbackStyleVersion'],
  data() {
    return { defaultIcon: DEFAULT_ICON };
  },
  methods: {
    handleGridClick(item, index) {
      SPM.clickButton({
        buttonName: 'Welfare_onlineretailers_channel_gird',
        businessInfo: {
          adsource: ParamsUtil.getParam('adsource') || '',
          buyicon_name: item?.gridName || '',
          rankNum: index + 1,
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
      this.$emit('grid-click', item);
    },
    handleGridExpose(_entry, { item, index }) {
      SPM.moduleExpose({
        moduleId: 'Welfare_onlineretailers_channel_gird',
        contentId: 'Welfare_onlineretailers_channel_gird',
        exposureTimes: 1,
        businessInfo: {
          adsource: ParamsUtil.getParam('adsource') || '',
          buyicon_name: item?.gridName || '',
          rankNum: index + 1,
          takeoutTestVersion: this.cashbackStyleVersion(),
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.grid-list-icon {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.06rem;
  scrollbar-width: none;
  padding: 0 0.01rem;
  margin: 0.12rem 0 0.16rem;

  &::-webkit-scrollbar {
    display: none;
  }

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.grid-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.grid-icon-wrapper {
  position: relative;

  .corner-text {
    position: absolute;
    right: -0.14rem;
    top: -0.06rem;
    color: #fff;
    background-color: #f72626;
    border: 0.01rem solid #fff;
    padding: 0 0.04rem;
    font-size: 0.11rem;
    display: flex;
    align-items: center;
    height: 0.16rem;
    border-radius: 0.08rem;
  }
}

.grid-icon {
  display: block;
  width: 0.54rem;
  height: 0.54rem;
  border-radius: 0.15rem;
}

.grid-name {
  font-size: 0.13rem;
  line-height: 0.17rem;
  height: 0.18rem;
  font-weight: 500;
  color: #242729;
  white-space: nowrap;
  width: 0.96rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0.06rem;
}

.grid-subtitle {
  font-size: 0.12rem;
  color: #000;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 0.73rem;
  height: 0.28rem;
  background-color: #ffe888;
  border-radius: 0.14rem;
  margin-top: 0.06rem;
}
</style>
